import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";

// Sample module data
const cardList = [
  {
    id: 1,
    name: "I.P.D.",
    desc: "Manage indoor patient records, admissions, discharges, and treatments efficiently.",
  },
  {
    id: 2,
    name: "O.T. Management",
   
    desc: "Optimize operation theater bookings, schedules, and surgical records.",
  },
  {
    id: 3,
    name: "Radiology / Pathology",
    desc: "Integrated diagnostic services with result tracking and reporting.",
  },
  {
    id: 4,
    name: "Organization/TPA",
   
    desc: "Manage tie-ups with organizations and third-party administrators (TPAs).",
  },
  {
    id: 5,
    name: "Pharmacy",
  
    desc: "Maintain drug inventory, billing, and issuance to patients.",
  },
  {
    id: 6,
    name: "Inventory",
   
    desc: "Track medical supplies, consumables, and stock levels.",
  },
  {
    id: 7,
    name: "Financial Accounts",
    
    desc: "Control billing, receipts, payments, and financial reports.",
  },
  {
    id: 8,
    name: "M.I.S",
   
    desc: "Powerful reporting module for strategic decisions.",
  },
  {
    id: 9,
    name: "SMS Module",
   
    desc: "Send appointment reminders, billing alerts via SMS.",
  },
  {
    id: 10,
    name: "Nursing Station",
   
    desc: "Interface for nurses to manage patient vitals and rounds.",
  },
  {
    id: 11,
    name: "Asset / Machine Maintenance",
    
    desc: "Schedule and track medical equipment maintenance.",
  },
  {
    id: 12,
    name: "Blood Bank",
   
    desc: "Manage donors, blood inventory, and transfusion records.",
  },
  {
    id: 13,
    name: "MIS on Mobile",
  
    desc: "Access hospital reports and data on mobile devices.",
  },
  {
    id: 14,
    name: "Payroll",
   
    desc: "Automate employee payroll, attendance, and deductions.",
  },
];

// Array of gradient backgrounds (for the grid)
const gradients = [
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
 "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
  "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)",
];

const OTBookings = () => {
  const [show, setShow] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const handleShow = (card) => {
    setSelectedCard(card);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setSelectedCard(null);
  };

  return (
    <div className="container mb-5">
      <h2 className="text-start fw-bold mb-2" style={{fontSize:'24px'}}>Hospital Modules</h2>
      <div className="row g-4">
        {cardList.map((card, index) => (
          <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={card.id}>
            <div
              className="card text-center p-3 h-100 shadow-sm border-0 card-hover text-white"
              onClick={() => handleShow(card)}
              style={{
                      textAlign: "center",
                      padding: "40px 20px",
                      background: gradients[index % gradients.length],
                      borderRadius: "12px",
                      border: "2px dashed #bae6fd",
                    }}>
               
              <div
                      style={{
                        width: "60px",
                        height: "60px",
                        background:
                          "linear-gradient(135deg, #0284c7 0%, #0369a1 100%)",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "0 auto 16px",
                        boxShadow: "0 6px 20px rgba(2, 132, 199, 0.3)",
                      }}
                    >
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                          stroke="white"
                          strokeWidth="2"
                          fill="white"
                          fillOpacity="0.2"
                        />
                      </svg>
                    </div>
              <h6 className="fw-bold" style={{color: "#0369a1",}}>{card.name}</h6>
              <p className="small" style={{color: "#0369a1",}}>{card.desc}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal */}
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Body className="d-flex justify-content-center align-items-center p-4">
          <div
            style={{
              textAlign: "center",
              padding: "40px 20px",
              background: "#f0f9ff",
              borderRadius: "12px",
              border: "2px dashed #bae6fd",
              minWidth: "270px",
              maxWidth: "360px",
              margin: "0 auto",
              boxShadow: "none",
            }}
          >
            {/* Shield Icon */}
            <div
              style={{
                width: "60px",
                height: "60px",
                background: "#0284c7",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                boxShadow: "0 6px 20px rgba(2, 132, 199, 0.10)",
              }}
            >
              <svg
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                aria-hidden="true"
              >
                <path
                  d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                  stroke="white"
                  strokeWidth="2"
                  fill="white"
                  fillOpacity="0.16"
                />
              </svg>
            </div>
            <h4
              style={{
                fontSize: "18px",
                fontWeight: "600",
                color: "#0369a1",
                marginBottom: "8px",
              }}
            >
              Coming Soon
            </h4>
            <p
              style={{
                fontSize: "14px",
                color: "#0284c7",
                opacity: "0.80",
                margin: 0,
              }}
            >
              {selectedCard
                ? selectedCard.desc + " module under development"
                : "This module is under development"}
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center pb-4 border-0">
          <Button variant="outline-secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Hover styles */}
      <style>{`
        .card-hover:hover {
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
          transform: translateY(-6px);
        }
      `}</style>
    </div>
  );
};

export default OTBookings;
